import { atom } from 'jotai';

export const showLostConnectionAtom = atom<boolean>(false);
